import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddLocationAltOutlinedIcon from "@mui/icons-material/AddLocationAltOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AirOutlinedIcon from "@mui/icons-material/AirOutlined";
import AirlineSeatFlatOutlinedIcon from "@mui/icons-material/AirlineSeatFlatOutlined";
import AirlineSeatIndividualSuiteOutlinedIcon from "@mui/icons-material/AirlineSeatIndividualSuiteOutlined";
import AirlineSeatLegroomExtraOutlinedIcon from "@mui/icons-material/AirlineSeatLegroomExtraOutlined";
import AirlineSeatReclineExtraOutlinedIcon from "@mui/icons-material/AirlineSeatReclineExtraOutlined";
import AirlinesOutlinedIcon from "@mui/icons-material/AirlinesOutlined";
import AirplaneTicketOutlinedIcon from "@mui/icons-material/AirplaneTicketOutlined";
import AllInclusiveOutlinedIcon from "@mui/icons-material/AllInclusiveOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import AnchorOutlinedIcon from "@mui/icons-material/AnchorOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import ApprovalOutlinedIcon from "@mui/icons-material/ApprovalOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AssistWalkerOutlinedIcon from "@mui/icons-material/AssistWalkerOutlined";
import AtmOutlinedIcon from "@mui/icons-material/AtmOutlined";
import AudioFileOutlinedIcon from "@mui/icons-material/AudioFileOutlined";
import BabyChangingStationOutlinedIcon from "@mui/icons-material/BabyChangingStationOutlined";
import BackpackOutlinedIcon from "@mui/icons-material/BackpackOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import BentoOutlinedIcon from "@mui/icons-material/BentoOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import BlindOutlinedIcon from "@mui/icons-material/BlindOutlined";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import BookOnlineOutlinedIcon from "@mui/icons-material/BookOnlineOutlined";
import BreakfastDiningOutlinedIcon from "@mui/icons-material/BreakfastDiningOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import BungalowOutlinedIcon from "@mui/icons-material/BungalowOutlined";
import BusAlertOutlinedIcon from "@mui/icons-material/BusAlertOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CalendarViewWeekOutlinedIcon from "@mui/icons-material/CalendarViewWeekOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CameraIndoorOutlinedIcon from "@mui/icons-material/CameraIndoorOutlined";
import CameraOutdoorOutlinedIcon from "@mui/icons-material/CameraOutdoorOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CarRentalOutlinedIcon from "@mui/icons-material/CarRentalOutlined";
import CarRepairOutlinedIcon from "@mui/icons-material/CarRepairOutlined";
import CarpenterOutlinedIcon from "@mui/icons-material/CarpenterOutlined";
import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import CellTowerOutlinedIcon from "@mui/icons-material/CellTowerOutlined";
import ChairAltOutlinedIcon from "@mui/icons-material/ChairAltOutlined";
import ChildFriendlyOutlinedIcon from "@mui/icons-material/ChildFriendlyOutlined";
import CleanHandsOutlinedIcon from "@mui/icons-material/CleanHandsOutlined";
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import CoPresentOutlinedIcon from "@mui/icons-material/CoPresentOutlined";
import CommuteOutlinedIcon from "@mui/icons-material/CommuteOutlined";
import ComputerOutlinedIcon from "@mui/icons-material/ComputerOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import ContactEmergencyOutlinedIcon from "@mui/icons-material/ContactEmergencyOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CribOutlinedIcon from "@mui/icons-material/CribOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import DeliveryDiningOutlinedIcon from "@mui/icons-material/DeliveryDiningOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import DeskOutlinedIcon from "@mui/icons-material/DeskOutlined";
import DirectionsRailwayOutlinedIcon from "@mui/icons-material/DirectionsRailwayOutlined";
import DirectionsSubwayOutlinedIcon from "@mui/icons-material/DirectionsSubwayOutlined";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import Diversity2OutlinedIcon from "@mui/icons-material/Diversity2Outlined";
import DoorFrontOutlinedIcon from "@mui/icons-material/DoorFrontOutlined";
import DoorSlidingOutlinedIcon from "@mui/icons-material/DoorSlidingOutlined";
import DoorbellOutlinedIcon from "@mui/icons-material/DoorbellOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import EggOutlinedIcon from "@mui/icons-material/EggOutlined";
import ElevatorOutlinedIcon from "@mui/icons-material/ElevatorOutlined";
import EmergencyShareOutlinedIcon from "@mui/icons-material/EmergencyShareOutlined";
import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";
import EmojiFoodBeverageOutlinedIcon from "@mui/icons-material/EmojiFoodBeverageOutlined";
import EmojiNatureOutlinedIcon from "@mui/icons-material/EmojiNatureOutlined";
import EnergySavingsLeafOutlinedIcon from "@mui/icons-material/EnergySavingsLeafOutlined";
import EvStationOutlinedIcon from "@mui/icons-material/EvStationOutlined";
import EventSeatOutlinedIcon from "@mui/icons-material/EventSeatOutlined";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import FireTruckOutlinedIcon from "@mui/icons-material/FireTruckOutlined";
import FoodBankOutlinedIcon from "@mui/icons-material/FoodBankOutlined";
import GarageOutlinedIcon from "@mui/icons-material/GarageOutlined";
import GasMeterOutlinedIcon from "@mui/icons-material/GasMeterOutlined";
import GiteOutlinedIcon from "@mui/icons-material/GiteOutlined";
import GolfCourseOutlinedIcon from "@mui/icons-material/GolfCourseOutlined";
import GrassOutlinedIcon from "@mui/icons-material/GrassOutlined";
import HailOutlinedIcon from "@mui/icons-material/HailOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import IcecreamOutlinedIcon from "@mui/icons-material/IcecreamOutlined";
import IronOutlinedIcon from "@mui/icons-material/IronOutlined";
var muiIcon = function (key, label, Icon) { return ({
    key: "mui-".concat(key),
    label: label,
    search: "".concat(label, " ").concat(key.replace(/-/g, " "), " mui material icon"),
    Icon: Icon,
}); };
export var ADDITIONAL_MUI_SECTOR_ICONS = [
    muiIcon("access-alarm", "Access alarm", AccessAlarmOutlinedIcon),
    muiIcon("account-balance", "Account balance", AccountBalanceOutlinedIcon),
    muiIcon("account-balance-wallet", "Account balance wallet", AccountBalanceWalletOutlinedIcon),
    muiIcon("account-box", "Account box", AccountBoxOutlinedIcon),
    muiIcon("account-circle", "Account circle", AccountCircleOutlinedIcon),
    muiIcon("add-location-alt", "Add location alt", AddLocationAltOutlinedIcon),
    muiIcon("admin-panel-settings", "Admin panel settings", AdminPanelSettingsOutlinedIcon),
    muiIcon("air", "Air", AirOutlinedIcon),
    muiIcon("airline-seat-flat", "Airline seat flat", AirlineSeatFlatOutlinedIcon),
    muiIcon("airline-seat-individual-suite", "Airline seat individual suite", AirlineSeatIndividualSuiteOutlinedIcon),
    muiIcon("airline-seat-legroom-extra", "Airline seat legroom extra", AirlineSeatLegroomExtraOutlinedIcon),
    muiIcon("airline-seat-recline-extra", "Airline seat recline extra", AirlineSeatReclineExtraOutlinedIcon),
    muiIcon("airlines", "Airlines", AirlinesOutlinedIcon),
    muiIcon("airplane-ticket", "Airplane ticket", AirplaneTicketOutlinedIcon),
    muiIcon("all-inclusive", "All inclusive", AllInclusiveOutlinedIcon),
    muiIcon("analytics", "Analytics", AnalyticsOutlinedIcon),
    muiIcon("anchor", "Anchor", AnchorOutlinedIcon),
    muiIcon("announcement", "Announcement", AnnouncementOutlinedIcon),
    muiIcon("approval", "Approval", ApprovalOutlinedIcon),
    muiIcon("article", "Article", ArticleOutlinedIcon),
    muiIcon("assist-walker", "Assist walker", AssistWalkerOutlinedIcon),
    muiIcon("atm", "ATM", AtmOutlinedIcon),
    muiIcon("audio-file", "Audio file", AudioFileOutlinedIcon),
    muiIcon("baby-changing-station", "Baby changing station", BabyChangingStationOutlinedIcon),
    muiIcon("backpack", "Backpack", BackpackOutlinedIcon),
    muiIcon("balance", "Balance", BalanceOutlinedIcon),
    muiIcon("bento", "Bento", BentoOutlinedIcon),
    muiIcon("biotech", "Biotech", BiotechOutlinedIcon),
    muiIcon("blind", "Blind", BlindOutlinedIcon),
    muiIcon("book", "Book", BookOutlinedIcon),
    muiIcon("book-online", "Book online", BookOnlineOutlinedIcon),
    muiIcon("breakfast-dining", "Breakfast dining", BreakfastDiningOutlinedIcon),
    muiIcon("brush", "Brush", BrushOutlinedIcon),
    muiIcon("bungalow", "Bungalow", BungalowOutlinedIcon),
    muiIcon("bus-alert", "Bus alert", BusAlertOutlinedIcon),
    muiIcon("business", "Business", BusinessOutlinedIcon),
    muiIcon("calculate", "Calculate", CalculateOutlinedIcon),
    muiIcon("calendar-today", "Calendar today", CalendarTodayOutlinedIcon),
    muiIcon("calendar-view-week", "Calendar view week", CalendarViewWeekOutlinedIcon),
    muiIcon("call", "Call", CallOutlinedIcon),
    muiIcon("camera-indoor", "Camera indoor", CameraIndoorOutlinedIcon),
    muiIcon("camera-outdoor", "Camera outdoor", CameraOutdoorOutlinedIcon),
    muiIcon("campaign", "Campaign", CampaignOutlinedIcon),
    muiIcon("car-rental", "Car rental", CarRentalOutlinedIcon),
    muiIcon("car-repair", "Car repair", CarRepairOutlinedIcon),
    muiIcon("carpenter", "Carpenter", CarpenterOutlinedIcon),
    muiIcon("casino", "Casino", CasinoOutlinedIcon),
    muiIcon("category", "Category", CategoryOutlinedIcon),
    muiIcon("cell-tower", "Cell tower", CellTowerOutlinedIcon),
    muiIcon("chair-alt", "Chair alt", ChairAltOutlinedIcon),
    muiIcon("child-friendly", "Child friendly", ChildFriendlyOutlinedIcon),
    muiIcon("clean-hands", "Clean hands", CleanHandsOutlinedIcon),
    muiIcon("cloud", "Cloud", CloudOutlinedIcon),
    muiIcon("co-present", "Co present", CoPresentOutlinedIcon),
    muiIcon("commute", "Commute", CommuteOutlinedIcon),
    muiIcon("computer", "Computer", ComputerOutlinedIcon),
    muiIcon("confirmation-number", "Confirmation number", ConfirmationNumberOutlinedIcon),
    muiIcon("contact-emergency", "Contact emergency", ContactEmergencyOutlinedIcon),
    muiIcon("contact-mail", "Contact mail", ContactMailOutlinedIcon),
    muiIcon("contact-phone", "Contact phone", ContactPhoneOutlinedIcon),
    muiIcon("contacts", "Contacts", ContactsOutlinedIcon),
    muiIcon("corporate-fare", "Corporate fare", CorporateFareOutlinedIcon),
    muiIcon("credit-card", "Credit card", CreditCardOutlinedIcon),
    muiIcon("crib", "Crib", CribOutlinedIcon),
    muiIcon("dark-mode", "Dark mode", DarkModeOutlinedIcon),
    muiIcon("delivery-dining", "Delivery dining", DeliveryDiningOutlinedIcon),
    muiIcon("design-services", "Design services", DesignServicesOutlinedIcon),
    muiIcon("desk", "Desk", DeskOutlinedIcon),
    muiIcon("directions-railway", "Directions railway", DirectionsRailwayOutlinedIcon),
    muiIcon("directions-subway", "Directions subway", DirectionsSubwayOutlinedIcon),
    muiIcon("directions-walk", "Directions walk", DirectionsWalkOutlinedIcon),
    muiIcon("diversity1", "Diversity1", Diversity1OutlinedIcon),
    muiIcon("diversity2", "Diversity2", Diversity2OutlinedIcon),
    muiIcon("door-front", "Door front", DoorFrontOutlinedIcon),
    muiIcon("door-sliding", "Door sliding", DoorSlidingOutlinedIcon),
    muiIcon("doorbell", "Doorbell", DoorbellOutlinedIcon),
    muiIcon("draw", "Draw", DrawOutlinedIcon),
    muiIcon("egg", "Egg", EggOutlinedIcon),
    muiIcon("elevator", "Elevator", ElevatorOutlinedIcon),
    muiIcon("emergency-share", "Emergency share", EmergencyShareOutlinedIcon),
    muiIcon("emoji-emotions", "Emoji emotions", EmojiEmotionsOutlinedIcon),
    muiIcon("emoji-food-beverage", "Emoji food beverage", EmojiFoodBeverageOutlinedIcon),
    muiIcon("emoji-nature", "Emoji nature", EmojiNatureOutlinedIcon),
    muiIcon("energy-savings-leaf", "Energy savings leaf", EnergySavingsLeafOutlinedIcon),
    muiIcon("ev-station", "EV station", EvStationOutlinedIcon),
    muiIcon("event-seat", "Event seat", EventSeatOutlinedIcon),
    muiIcon("explore", "Explore", ExploreOutlinedIcon),
    muiIcon("factory", "Factory", FactoryOutlinedIcon),
    muiIcon("feed", "Feed", FeedOutlinedIcon),
    muiIcon("fire-truck", "Fire truck", FireTruckOutlinedIcon),
    muiIcon("food-bank", "Food bank", FoodBankOutlinedIcon),
    muiIcon("garage", "Garage", GarageOutlinedIcon),
    muiIcon("gas-meter", "Gas meter", GasMeterOutlinedIcon),
    muiIcon("gite", "Gite", GiteOutlinedIcon),
    muiIcon("golf-course", "Golf course", GolfCourseOutlinedIcon),
    muiIcon("grass", "Grass", GrassOutlinedIcon),
    muiIcon("hail", "Hail", HailOutlinedIcon),
    muiIcon("home-work", "Home work", HomeWorkOutlinedIcon),
    muiIcon("icecream", "Icecream", IcecreamOutlinedIcon),
    muiIcon("iron", "Iron", IronOutlinedIcon),
];
